{
  "seriousBusiness": {
    "title": "Negocio Serio",
    "subtitle": "Para profesionales que hacen negocios importantes, estos son los botones. Úsalos con criterio."
  },
  "addFboLabel": "Añadir un nuevo FBO",
  "deleteFboLabel": "Eliminar <u>este</u> FBO",
  "currentFbos": {
    "title": "FBOs actuales",
    "subtitle": "Modifica el campo de texto para cambiar el nombre del FBO. Cambia su suscripción (acceso a funciones restringidas) seleccionando en el menú desplegable."
  },
  "subscriptionLabel": "Suscripción",
  "subscriptions": {
    "standard": "Estándar",
    "autostacking": "Autoapilado",
    "autostackingWithEdit": "Apilado automático con edición de hangar/plataforma",
    "autostackingWithEditAndCopy": "Apilado automático con edición y copia de hangar/plataforma",
    "inactive": "Inactivo"
  }
}
